module.exports = __webpack_public_path__ + "static/logo-with-text-257bbffc6dcac5076e8ac31eed8ff73c.svg";